import { IPlan, ITask, IRhytSortingData, IBarsortingData, IFlowData, IEmbedData, ISubScoreData } from "../types";
import getScore from "../../front/components/Task/types/Common/getScore";
import { parseScoreToBoxes } from "../../front/components/Task/types/RhytSorting/utils";
import { IPlanDocument } from "../../api/config/models/plan";

export const checkPlayable = (task: ITask, plan: IPlan | IPlanDocument) => {
    if (!task) return false;
    let score = getScore(plan as IPlan, task);
    if (task.type === "rhytSorting") {
        if (task.data && (task.data as IRhytSortingData).boxes && (task.data as IRhytSortingData).boxes.length >= 2) {
            return true;
        }
        if (task.ref) {
            const { bars, isValidRhythms } = parseScoreToBoxes(score);
            if (bars.length >= 2 && isValidRhythms) {
                return true;
            }
        }
        return false;
    } else if (task.type === "barSorting") {
        if (task.data && (task.data as IBarsortingData).drags && (task.data as IBarsortingData).drags!.length) {
            return true;
        }
        return false;
    } else if (
        task.type === "melodyTable" ||
        task.type === "tonesetStaff" ||
        task.type === "solfaName" ||
        task.type === "piano" ||
        task.type === "barSorting2" ||
        task.type === "handSign" ||
        task.type === "singing"
    ) {
        let totalNotes = [0, 0, 0, 0, 0, 0];
        if (!score || !score.bars) return false;
        for (let v = 0; v < 6; v++) {
            const bars = score["bars" + (v || "")];
            if (!bars) continue;
            for (let a = 0; a < bars.length; a++) {
                let bar = bars[a];
                if (bar && bar.notes && bar.notes.length) {
                    for (let n = 0; n < bar.notes.length; n++) {
                        totalNotes[v]++;
                        let note = bar.notes[n];
                        if (!note.p && !note.r) {
                            return false;
                        }
                    }
                }
            }
        }
        if ((task.type === "tonesetStaff" || task.type === "melodyTable") && score.keyChanges && score.keyChanges.length > 0) {
            return false;
        }
        if (totalNotes[0] >= 2) {
            return true;
        }
        return false;
    } else if (task.type === "intervals" || task.type === "chords3") {
        let totalNotes = 0;
        if (!score || !score.bars) return false;
        const bars = score.bars;
        for (let a = 0; a < bars.length; a++) {
            let bar = bars[a];
            if (bar && bar.notes && bar.notes.length) {
                for (let n = 0; n < bar.notes.length; n++) {
                    totalNotes++;
                    let note = bar.notes[n];
                    if (!note.p && !note.r) {
                        return false;
                    }
                    if (!Array.isArray(note.p)) return false;
                    if (task.type === "intervals" && note.p.length !== 2) return false;
                    if (task.type === "chords3" && (note.p.length !== 3 && note.p.length !== 4)) return false;
                }
            }
        }
        if (totalNotes >= 2) {
            return true;
        }
        return false;
    } else if (
        task.type === "rhytName" ||
        task.type === "rhytNotation" ||
        task.type === "flow" ||
        task.type === "rhytKnock" ||
        task.type === "barline"
    ) {
        let totalRhyt = 0;
        if (task.type === "flow") {
            score = (task.data as IFlowData)?.scores?.[0];
        }
        if (score) {
            let { bars } = score;
            for (let a = 0; a < bars.length; a++) {
                let bar = bars[a];
                if (bar && bar.notes && bar.notes.length) {
                    for (let n = 0; n < bar.notes.length; n++) {
                        if (!bar.notes[n].r) {
                            totalRhyt++;
                        }
                    }
                }
            }
        }
        if (totalRhyt >= 2) {
            return true;
        }
        return false;
    } else if (task.type === "embed") {
        if (task.data && (task.data as IEmbedData).href) {
            return true;
        }
        return false;
    } else if (task.type === "subScore") {
        if (task.data &&
            (task.data as ISubScoreData).href &&
            (task.data as ISubScoreData).scores &&
            (task.data as ISubScoreData).scores.length > 0 &&
            (task.data as ISubScoreData).points &&
            (task.data as ISubScoreData).points.length > 0
        ) {
            return true;
        }
        return false;
    }
    return false;
};

export const checkTasksPlayable = (tasks: ITask[], plan: IPlan | IPlanDocument) => {
    let playable = true;
    tasks.forEach(task => {
        if (!checkPlayable(task, plan)) {
            playable = false;
        }
    });
    if (playable && plan.experience.enabled && plan.experience.positions.filter(pos => typeof pos === "number" || Array.isArray(pos)).length === 0) {
        playable = false;
    }
    return playable;
};